function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image } from "expo-image";
import hexToRgba from "hex-to-rgba";
import { useEffect, useState } from "react";
import { Image as RNImage, StyleSheet, TouchableOpacity } from "react-native";
import { Icon } from "./Icon";
import { Pill } from "./Pill";
import { SvgUri } from "./SvgUri";
import { Label, Text } from "./Text";
import { View } from "./View";
import { useI18n } from "../lib/i18n";
import { card, useTheme } from "../styles";
function getV2SessionSvg(num, completed) {
    return /*#__PURE__*/ _jsx(SvgUri, {
        uri: "https://storage.googleapis.com/asset.oui.dev/static/Learn_Session_".concat(completed ? 'complete_' : '').concat(num, ".svg")
    });
}
function getV2StaticSessionSvg(num, completed) {
    return /*#__PURE__*/ _jsx(SvgUri, {
        uri: "https://storage.googleapis.com/asset.oui.dev/static/LearnStatic_Session_".concat(completed ? 'complete_' : '').concat(num, ".svg")
    });
}
var BORDER_WIDTH = 2;
var COMPLETE_COLOR = '#18655a';
var COMPLETE_COLOR_BACKGROUND = hexToRgba('#c7f0b7', 0.3);
function SessionCardTitle(param) {
    var header = param.header, state = param.state, unlockedAt = param.unlockedAt, title = param.title, subtitle = param.subtitle;
    var theme = useTheme().theme;
    var formatDate = useI18n().formatDate;
    var isComplete = state === 'complete';
    var titleColor, subtitleColor;
    var opacity = undefined;
    if (isComplete) {
        titleColor = COMPLETE_COLOR;
        subtitleColor = COMPLETE_COLOR;
    } else if (state === 'locked') {
        titleColor = theme.color.gray100;
        subtitleColor = theme.color.gray200;
        if (!unlockedAt) {
            opacity = 0.7;
        }
    }
    return /*#__PURE__*/ _jsx(View, {
        row: true,
        flex: 1,
        children: /*#__PURE__*/ _jsxs(View, {
            row: true,
            flex: 1,
            style: {
                alignItems: 'flex-start',
                opacity: opacity
            },
            spacing: 14,
            children: [
                header ? /*#__PURE__*/ _jsx(Text, {
                    // if header is '0' we don't actually want to show 0 as a number since a "0" session
                    // isn't actually session 0, it's just the session before 1
                    text: header === '0' ? ' ' : header,
                    weight: "semibold",
                    size: 17,
                    color: titleColor
                }) : null,
                title ? /*#__PURE__*/ _jsxs(View, {
                    flex: 1,
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            row: true,
                            spacing: 9,
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    text: title,
                                    weight: "semibold",
                                    size: 17,
                                    color: titleColor
                                }),
                                state === 'active' || state === 'unlocked' ? /*#__PURE__*/ _jsx(View, {
                                    pointerEvents: "none",
                                    style: {
                                        marginTop: 3
                                    },
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        name: "arrow-right",
                                        color: theme.color.primary100
                                    })
                                }) : null
                            ]
                        }),
                        subtitle ? /*#__PURE__*/ _jsx(Text, {
                            text: subtitle,
                            color: subtitleColor,
                            style: {
                                maxWidth: '85%'
                            }
                        }) : null,
                        unlockedAt ? /*#__PURE__*/ _jsxs(View, {
                            row: true,
                            style: {
                                marginTop: 15,
                                gap: 5
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Label, {
                                    text: "Unlocks",
                                    small: true
                                }),
                                /*#__PURE__*/ _jsx(Pill, {
                                    size: "medium",
                                    backgroundColor: "white",
                                    color: theme.color.gray200,
                                    text: formatDate(unlockedAt, {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    })
                                })
                            ]
                        }) : null
                    ]
                }) : null,
                state === 'locked' ? /*#__PURE__*/ _jsx(View, {
                    style: {
                        alignItems: 'flex-end'
                    },
                    children: /*#__PURE__*/ _jsx(Icon, {
                        name: "lock",
                        color: theme.color.gray400,
                        size: 18
                    })
                }) : null
            ]
        })
    });
}
/**
 * Renders a locked preview of a
 * <https://ouihealth.atlassian.net/browse/APPCORE-118>
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-118}
 */ export function SessionIncompleteLockCard(props) {
    var scheme = useTheme().scheme;
    return /*#__PURE__*/ _jsx(View, {
        testID: props.testID,
        accessible: true,
        "aria-label": "Complete session ".concat(props.num, " to unlock."),
        role: "button",
        "aria-disabled": true,
        style: [
            styles.component,
            styles.locked,
            {
                backgroundColor: scheme === 'dark' ? '#121212' : '#EFF0F3'
            }
        ],
        children: /*#__PURE__*/ _jsx(SessionCardTitle, {
            title: '',
            subtitle: undefined,
            state: "locked",
            header: "Complete session ".concat(props.num)
        })
    });
}
function NaturalSizeImage(props) {
    var _useState = _sliced_to_array(useState(), 2), size = _useState[0], setSize = _useState[1];
    useEffect(function() {
        var cancelled = false;
        var uri = _type_of(props.source) === 'object' && props.source && 'uri' in props.source ? props.source.uri : undefined;
        if (uri) {
            if (uri.endsWith('.svg')) {
                fetch(uri).then(function(r) {
                    return r.text();
                }).then(function(xmlString) {
                    var _xmlString_split_slice_find_match, _xmlString_split_slice_find;
                    var _xmlString_split_slice_find_match_map;
                    var _ref = _sliced_to_array((_xmlString_split_slice_find_match_map = (_xmlString_split_slice_find = xmlString.split('\n').slice(0, 3).find(function(line) {
                        return line.match(/viewBox=".*"/i);
                    })) === null || _xmlString_split_slice_find === void 0 ? void 0 : (_xmlString_split_slice_find_match = _xmlString_split_slice_find.match(/viewBox="(\d+) (\d+) (\d+) (\d+)"/i)) === null || _xmlString_split_slice_find_match === void 0 ? void 0 : _xmlString_split_slice_find_match.map(function(v) {
                        return Number.parseFloat(v);
                    })) !== null && _xmlString_split_slice_find_match_map !== void 0 ? _xmlString_split_slice_find_match_map : [], 5), _full = _ref[0], x = _ref[1], y = _ref[2], width = _ref[3], height = _ref[4];
                    if (width && height) {
                        setSize({
                            width: width - x,
                            height: height - y
                        });
                    } else {
                        // fall back to aspect ratio of 1
                        setSize({
                            width: 90,
                            height: 90
                        });
                    }
                }).catch(function() {
                    // fall back to aspect ratio of 1
                    setSize({
                        width: 90,
                        height: 90
                    });
                });
            } else {
                RNImage.getSize(uri, function(width, height) {
                    if (!cancelled) {
                        setSize({
                            width: width,
                            height: height
                        });
                    }
                });
            }
        }
        return function() {
            cancelled = true;
        };
    }, [
        props.source
    ]);
    return /*#__PURE__*/ _jsx(Image, _object_spread_props(_object_spread({}, props), {
        style: {
            width: 90,
            aspectRatio: size ? size.width / size.height : 1
        }
    }));
}
/**
 * Displays a pressable card for a Learn session. Can be in one of the following
 * states:
 *
 * `'locked' | 'active' | 'session-complete' | 'unlocked';`
 *
 *
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̅̀̀̆̅̀̀̆̃̀̀̃̈̀̀̃̉̀̀̃̃̀̀̃̃̀̀̂̍̀̀̆̂̀̀̃̆̀̀̃̅̀̀̃̇̀̀̂̍̀̀̃̄̀̀̃̆̀̀̆̅̀̀̆̄̀̀̂̍̀̀̆̂̀̀̃̆̀̀̃̂̀̀̆̂̀̀̂̍̀̀̃́̀̀̃̀̀̀̃̄̀̀̃̃̀̀̃̃̀̀̃̈̀̀̃̇̀̀̆̃̀̀̆̅̀̀̃̆̀̀̃̃̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̈̀̀̃̂̀̀̃̆̀̀̂̍̀̀̃̂̀̀̃́̀̀̃̃̀̀̃̃̀̀̃̃̀̀̃̄̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̃̀̀̃̇̀̀̃̇̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̃̀̀̃̂̀̀̃̇̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-13}
 */ export function SessionCard(props) {
    var theme = useTheme().theme;
    var header = props.hideHeader ? '' : props.session.num.toString();
    var state = props.state;
    if (state === 'locked') {
        var backgroundColor = props.unlockedAt ? theme.color.gray800 : theme.color.gray700;
        var borderColor = props.unlockedAt ? theme.color.gray600 : theme.color.gray700;
        var _props_session_title, _props_session_subtitle;
        return /*#__PURE__*/ _jsx(View, {
            accessible: true,
            "aria-label": "Session ".concat(header, ". ").concat((_props_session_title = props.session.title) !== null && _props_session_title !== void 0 ? _props_session_title : '', ". ").concat((_props_session_subtitle = props.session.subtitle) !== null && _props_session_subtitle !== void 0 ? _props_session_subtitle : '', ". locked"),
            role: "button",
            "aria-disabled": true,
            style: [
                styles.component,
                styles.locked,
                {
                    backgroundColor: backgroundColor,
                    borderColor: borderColor
                }
            ],
            testID: "".concat(props.testID, "_locked"),
            children: /*#__PURE__*/ _jsx(SessionCardTitle, {
                title: props.session.title,
                subtitle: props.session.subtitle,
                state: "locked",
                header: header,
                unlockedAt: props.unlockedAt
            })
        });
    }
    var isActive = state === 'active';
    var isComplete = state === 'complete';
    var collapsed = !isActive || props.session.details.length === 0;
    var expandedLabel = collapsed ? undefined : "Agenda: ".concat(props.session.details.join('.'), ".");
    var ariaLabel = "Session ".concat(props.session.num, ". ").concat(props.session.title, ". ").concat(props.session.subtitle, ". ").concat(expandedLabel, " ").concat(isComplete ? 'completed' : '');
    return /*#__PURE__*/ _jsx(View, {
        testID: props.testID,
        style: !isComplete ? [
            {
                borderRadius: 20,
                overflow: 'visible'
            }
        ] : null,
        children: /*#__PURE__*/ _jsxs(TouchableOpacity, {
            "aria-label": ariaLabel,
            role: "button",
            testID: "".concat(props.testID, "_top"),
            onPress: props.onPressTop,
            style: [
                styles.component,
                state === 'unlocked' ? {
                    borderColor: 'transparent',
                    backgroundColor: theme.color.gray800
                } : undefined,
                isActive ? {
                    borderColor: theme.color.primary100,
                    backgroundColor: 'white'
                } : null,
                isComplete ? {
                    borderColor: COMPLETE_COLOR_BACKGROUND,
                    backgroundColor: COMPLETE_COLOR_BACKGROUND
                } : null
            ],
            children: [
                /*#__PURE__*/ _jsx(View, {
                    style: {
                        position: 'absolute',
                        right: -BORDER_WIDTH,
                        bottom: -BORDER_WIDTH
                    },
                    children: props.session.illustrationUrl ? /*#__PURE__*/ _jsx(NaturalSizeImage, {
                        source: {
                            uri: props.session.illustrationUrl
                        },
                        resizeMode: "contain"
                    }) : props.static ? getV2StaticSessionSvg(props.session.num, isComplete) : getV2SessionSvg(props.session.num, isComplete)
                }),
                /*#__PURE__*/ _jsx(View, {
                    children: /*#__PURE__*/ _jsx(SessionCardTitle, {
                        title: props.session.title,
                        subtitle: props.session.subtitle,
                        state: state,
                        header: header
                    })
                }),
                collapsed ? null : /*#__PURE__*/ _jsxs(View, {
                    style: {
                        marginTop: 16,
                        marginStart: 22
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            text: "Agenda",
                            color: theme.color.gray300,
                            weight: "semibold",
                            style: {
                                marginBottom: 5
                            }
                        }),
                        props.session.details.map(function(detail, i) {
                            return /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    flexDirection: 'row',
                                    marginBottom: 8
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        text: '•',
                                        style: {
                                            marginEnd: 8,
                                            width: 10,
                                            textAlign: 'center',
                                            color: '#999'
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        text: "".concat(detail)
                                    })
                                ]
                            }, i);
                        })
                    ]
                })
            ]
        }, state)
    });
}
var styles = StyleSheet.create({
    component: {
        padding: 18,
        borderColor: 'transparent',
        borderWidth: BORDER_WIDTH,
        borderRadius: 20,
        overflow: 'hidden'
    },
    locked: {
        padding: 22
    }
});
/**
 * Renders a placeholder view for a
 * <https://ouihealth.atlassian.net/browse/APPCORE-118>
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-121}
 */ export function SessionCardBlank(props) {
    return /*#__PURE__*/ _jsx(View, {
        testID: props.testID,
        style: [
            {
                overflow: 'visible'
            }
        ],
        children: /*#__PURE__*/ _jsx(View, {
            style: [
                card,
                styles.component,
                [
                    {
                        borderColor: 'transparent',
                        minHeight: 80
                    }
                ]
            ],
            children: props.children
        })
    });
}
